import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { Close, GetApp, Visibility } from "@material-ui/icons";
import { useContext, useEffect, useState } from "react";
import { ArrayField, Button, ChipField, Datagrid, DateField, ListContextProvider, Loading, Pagination, SingleFieldList, TextField, useList, useRedirect } from "react-admin";
import { AppContext } from "../../../providers/app-context-provider/app.context";
import dataProvider from "../../../providers/data-provider";
import { SchoolStudentDashboardActivityReport } from "./school-student-dashboard-activity-report";

const SchoolStudentDashboardActivities = (props) => {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [loaded, setLoaded] = useState(false)
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(25)
    const [filters, setFilters] = useState({ has_finished: false })
    const [values, setValues] = useState({ 'status': 'active', 'academic_period': null });
    const [exportDialogOpen, setExportDialogOpen] = useState(false)
    const [academicPeriods, setAcademicPeriods] = useState([])

    const userContext = useContext(AppContext)

    useEffect(() => {
        (async () => {
            const resp = await dataProvider.get('school-activities', 'student-school-activities', { filter: JSON.stringify(filters), sort: '"school-activities.start_date"', order: '"DESC"' })
            setData(resp.data.data)
            setLoading(false)
            setLoaded(true)
        })()
    }, [filters])

    useEffect(() => {
        (async () => {
            const response = await dataProvider.getList(
                'academic-periods',
                {
                    pagination: { page: 1, perPage: 20 },
                    sort: { field: 'start_at', order: 'DESC' },
                })
                .then(res => setAcademicPeriods(res.data))
        })()
    }, [])

    const ids = data.map((row) => row.id)
    const sort = { field: 'start_date', order: 'DESC' };
    const context = useList({ data, ids, loading, loaded, page, perPage, sort, filter: {} })

    const handleDialogOpen = () => { setExportDialogOpen(true) }
    const handleDialogClose = () => { setExportDialogOpen(false) }

    const handleChange = (event) => {
        let value = event.target.value;
        setValues({ ...values, status: value });
        switch (value) {

            case 'all':
                const { has_finished, ...rest } = filters
                setFilters(rest)
                break;

            case 'active':
            default:
                setFilters(prev => ({ ...prev, has_finished: false }))
                break;

            case 'finished':
                setFilters(prev => ({ ...prev, has_finished: true }))
                break;
        }
    }

    const handleAcademicPeriodChange = (e) => {
        let value = e.target.value;
        setValues({ ...values, academic_period: value })
        setFilters({ ...filters, academic_period: e.target.value })
    }


    const reportData = {
        data,
        academicPeriod: academicPeriods.find((item) => item.id === filters.academic_period),
        status: filters.has_finished,
    }

    return (
        <Grid container spacing={2}>
            <Grid item container spacing={2}>
                <Grid container item direction="row" justifyContent="start">
                    <Grid item>
                        <FormControl style={{ marginBlock: '10px', marginInline: '10px', minWidth: '150px' }}>
                            <InputLabel style={{ padding: '4px' }} id={'filter-select-label'}>Status</InputLabel>
                            <Select
                                labelId={'filter-select-label'}
                                id={'filter-select'}
                                value={values.status}
                                disabled={loading}
                                onChange={handleChange}
                                variant="filled"
                            >
                                <MenuItem value={'all'}> Todas</MenuItem>
                                <MenuItem value={'active'}>Em aberto</MenuItem>
                                <MenuItem value={'finished'}>Finalizadas</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl style={{ marginBlock: '10px', marginInline: '10px', minWidth: '150px' }}>
                            <InputLabel style={{ padding: '4px' }} id={'filter-select-label-2'}>Período letivo</InputLabel>
                            <Select
                                labelId={'filter-select-label-2'}
                                id={'filter-select-2'}
                                value={values.academic_period}
                                disabled={loading}
                                onChange={handleAcademicPeriodChange}
                                variant="filled"
                            >
                                {
                                    academicPeriods?.map(
                                        (item) => <MenuItem value={item.id}>
                                            {`${item.name}`}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item style={{ flexGrow: 1 }} />
                    <Grid item alignContent="center" style={{ marginRight: '8px' }}>
                        <Button onClick={handleDialogOpen} variant="contained" label="Gerar relatório" startIcon={<GetApp />} />
                        <Dialog open={exportDialogOpen} onClose={handleDialogClose} maxWidth='lg' fullWidth>
                            <DialogTitle>{"Relatório de atividades do aluno"}</DialogTitle>
                            <DialogContent>
                                <SchoolStudentDashboardActivityReport data={reportData} context={userContext} />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleDialogClose} variant="contained" label="Fechar" startIcon={<Close />} />
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container>
                {
                    loading ? <Loading /> : <ListContextProvider value={context}>
                        <Datagrid basePath="/school-activities" resource="school-activities">
                            <TextField source="name" label={'Título'} />
                            <ArrayField source="teachers" label={'Professores Responsáveis'}>
                                <SingleFieldList linkType={false}>
                                    <ChipField source='user.name' />
                                </SingleFieldList>
                            </ArrayField>
                            <TextField source="class.name" label={'Turma'} locales={'pt-BR'} />
                            <TextField source="class.academic_period.name" label={'Período letivo'} />
                            <DateField source="start_date" label={'Início'} locales={'pt-BR'} />
                            <DateField source="end_date" label={'Fim previsto'} locales={'pt-BR'} />
                            <DashboardButton />
                        </Datagrid>
                        <Pagination page={page} setPage={setPage} setPerPage={setPerPage} perPage={perPage} rowsPerPageOptions={[25, 50, 100]} />
                    </ListContextProvider>
                }
            </Grid>
        </Grid>
    )
}


const DashboardButton = ({ record, resource, ...props }) => {
    const redirect = useRedirect()
    const handleClick = () => redirect(`/school-activity-dashboard/${record.id}`);

    return <Button label={'DASHBOARD'} size={'small'} onClick={handleClick}><Visibility /></Button>

}

export default SchoolStudentDashboardActivities